

export const scrollTo = () => {

    const scrollLink = document.querySelectorAll(".js-scroll-to");


    if ( scrollLink ) {

      for(var i = 0; i < scrollLink.length; i++ ){
        scrollLink[i].addEventListener("click", function(e){
          e.preventDefault();
       
          let elementId = this.dataset.scroll;

          if (elementId && elementId != '') {
            //console.log(elementId);
            //let elementGap = 0;
            let elementGap = document.getElementById(elementId)?.dataset.offset;
            if ( elementGap == undefined ) {
              elementGap = 0;
            }
            //console.log(elementGap);
            if ( window.innerWidth < 768 ) { elementGap = +elementGap * 0.75 ; }
            let elementPosition = document.getElementById(elementId).offsetTop - elementGap;

            if ( elementId == 'fonbet' ) {
              elementPosition = document.getElementById('business').offsetTop + document.getElementById(elementId).offsetTop - elementGap;
            }

            window.scrollTo({
              top: elementPosition,
              left: 0,
              behavior: 'smooth',
            });

            if ( document.querySelector(".header__menu_open") ) {
              document.querySelector(".header__menu_open").classList.remove("header__menu_open");
              document.querySelector(".header__burger_open").classList.remove("header__burger_open");
              document.querySelector(".header__outlinks_open").classList.remove("header__outlinks_open");
            }
          }

          

          

        });
      }

    }


    function scrollTo(element, to, duration) {
      if (duration <= 0) return;
      var difference = to - element.scrollTop;
      var perTick = difference / duration * 10;
  
      setTimeout(function() {
          element.scrollTop = element.scrollTop + perTick;
          if (element.scrollTop === to) return;
          scrollTo(element, to, duration - 10);
      }, 1000);
  }





    function scrollToAnchor() {
      const anchor = window.location.hash;
      if (anchor) {
          const targetElement = document.querySelector(anchor);
          if (targetElement) {
              const offset = parseInt(targetElement.getAttribute("data-offset")) || 0;

              console.log(offset);
              
              scrollTo(targetElement, targetElement.offsetTop - offset, 30);
              // Плавный скролл до элемента с учётом смещения
              window.scrollTo({
                  top: targetElement.offsetTop - offset,
                  behavior: "smooth"
              });
          }
      }
  }
  
 // scrollToAnchor();

}